import React from 'react';
import styles from './TextAlignment.module.css';

/** @param {string} textAlignment  */
function getTextAlignmentClass(textAlignment) {
  if (!textAlignment) {
    return '';
  }

  return styles[`textAlignment${textAlignment.replace(' ', '')}`];
}

/**
 * @param {object} props
 * @param {string} props.alignment
 * @param {string=} props.className
 * @param {React.ReactNode} props.children
 */
export default function TextAlignment({
  alignment,
  children,
  className = '',
  ...props
}) {
  return (
    <div
      className={`${getTextAlignmentClass(alignment)} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}
